export default function openLinkInNewTab(url) {
    window.open(url, '_blank', 'noopener,noreferrer');
}